import React, { useEffect, useState, Fragment } from "react";
import { Dialog } from "@progress/kendo-react-dialogs";
import "./About.css";
import { useSelector, useDispatch } from "react-redux";
import { setAboutWinOpen } from "../../redux/toolSelectSlice";
import * as ol from "ol";

const About = () => {
    const dispatch = useDispatch();
    const aboutWinOpen = useSelector((state) => state.toolSelect.aboutWinOpen);
    useEffect(() => {
        // console.log(aboutWinOpen);
    }, [aboutWinOpen]);

    const handleClose = (e) => {
        dispatch(setAboutWinOpen(false));
    };

    return (
        <>
            {aboutWinOpen && (
                <Dialog className={"centered-dialog"} style={{ maxWidth: "50vw" }}>
                    <h2>About</h2>
                    <div>Site Version: {process.env.REACT_APP_BUILD_NUMBER}</div>
                    <div>Openlayers Version: {ol.VERSION}</div>
                    <button
                        className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
                        onClick={handleClose}>
                        Close
                    </button>
                </Dialog>
            )}
        </>
    );
};
export default About;
